import { sharedDefaultConfigs } from '@pulse/browser-shared';
import { TrackerSharedConfigurations } from '@pulse/common';

export const trackerSharedConfigs: Required<TrackerSharedConfigurations> = {
    ...sharedDefaultConfigs,
    plugins: [],
    transformPipes: [],
    enrichmentPipes: [],

    sessionStorageType: 'persistent',
    tabManagerStorageType: 'tab',
    debug: [],

    //
    // STORAGE -----------------------------
    // -------------------------------------

    storagePrefix: 'paa_',
    tabOpenerDetectionTimeWindow: 6000,

    //
    // RUM -----------------------------
    // -------------------------------------
    rumUnsafeRequestBodyMeasure: true,
    rumReportOnce: [],
    rumReport: [],

    //
    // DataLayer -----------------------------
    // -------------------------------------
    dataLayerKey: 'dataLayer',
};
